import "../sass/7-bundles/special.scss";

async function loadSmooth() {
  import("../scripts/smooth.js");
  console.log("smooth");
}
async function loadForm() {
  import("../scripts/form.js");
  console.log("form");
}
async function loadContact() {
  import("../scripts/contactBtn.js");
  console.log("contact");
}

window.addEventListener("load", async function loadModules() {
  await loadSmooth();
  await loadContact();
  await loadForm();
});
